import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idFrom:"",
  idTo:"",
  licenseplateFrom:"",
  licenseplateTo:"",
  vehicleTrailerStoreFrom:"",
  vehicleTrailerStoreTo:"",
  enabled:true,
  notenabled:true 
};

const filtersVehiclesTrailersSlice = createSlice({
  name: 'filtersVehiclesTrailers',
  initialState,
  reducers: {
    setFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    },
  },
});

export const { setFilters, resetFilters } = filtersVehiclesTrailersSlice.actions;
export default filtersVehiclesTrailersSlice.reducer;
